<ng-container *ngFor="let form of forms$ | async; let index = index">
  <p-sidebar
    [visible]="form.isShowSidebar"
    (visibleChange)="closeSidebar($event, index)"
    position="right"
    [blockScroll]="true"
    [styleClass]="form.widthSize + ' ' + form.typeZIndex">
    <ng-template pTemplate="header">
      <div class="flex align-items-center justify-content-between gap-3 w-full">
        <p class="text-2xl font-bold">{{ form.headerText }}</p>
        <div *ngIf="form.isShowShare">
          <i
            class="pi pi-external-link cursor-pointer text-gray-500 hover:frm-color-blue mr-3"
            pTooltip="Поделиться"
            [showDelay]="300"
            tooltipPosition="bottom"
            style="font-size: 1.1rem"
            (click)="shareLinkForm(index)"></i>
        </div>
      </div>
    </ng-template>
    <ng-container [ngSwitch]="form.type">
      <crm-budget-task-form-sidebar
        *ngSwitchCase="TypeFormEnum.BUDGET_TASK"
        [index]="index"></crm-budget-task-form-sidebar>
      <crm-rate-plan-form
        *ngSwitchCase="TypeFormEnum.RATE_PLAN"
        [index]="index"></crm-rate-plan-form>
      <crm-contragent-form
        *ngSwitchCase="TypeFormEnum.CONTRAGENT"
        [index]="index"></crm-contragent-form>
      <crm-planned-income-form
        *ngSwitchCase="TypeFormEnum.PLANNED_INCOME"
        [index]="index"></crm-planned-income-form>
      <crm-direction-form
        *ngSwitchCase="TypeFormEnum.DIRECTION"
        [index]="index"></crm-direction-form>
      <crm-direction-group-form
        *ngSwitchCase="TypeFormEnum.DIRECTION_GROUP"
        [index]="index"></crm-direction-group-form>
      <crm-unit-form
        *ngSwitchCase="TypeFormEnum.UNIT"
        [index]="index"></crm-unit-form>
      <crm-filial-form
        *ngSwitchCase="TypeFormEnum.FILIAL"
        [index]="index"></crm-filial-form>
      <crm-room-form
        *ngSwitchCase="TypeFormEnum.ROOM"
        [index]="index"></crm-room-form>
      <crm-document-type-form
        *ngSwitchCase="TypeFormEnum.DOCUMENT_TYPE"
        [index]="index"></crm-document-type-form>
      <crm-operation-type-form
        *ngSwitchCase="TypeFormEnum.OPERATION_TYPE"
        [index]="index"></crm-operation-type-form>
      <crm-operation-type-erp-1c-form
        *ngSwitchCase="TypeFormEnum.OPERATION_TYPE_ERP_1C"
        [index]="index"></crm-operation-type-erp-1c-form>
      <crm-project-master-milestone-form
        *ngSwitchCase="TypeFormEnum.MASTER_MILESTONE"
        [index]="index"></crm-project-master-milestone-form>
      <crm-approval-scheme-form
        *ngSwitchCase="TypeFormEnum.APPROVAL_SCHEME"
        [index]="index"></crm-approval-scheme-form>
      <crm-task-form-sidebar
        *ngSwitchCase="TypeFormEnum.PAYMENT_TASK"
        [index]="index"></crm-task-form-sidebar>
      <crm-task-template-form
        *ngSwitchCase="TypeFormEnum.PAYMENT_TEMPLATE"
        [index]="index"></crm-task-template-form>
      <crm-payment-status-form
        *ngSwitchCase="TypeFormEnum.PAYMENT_STATUS"
        [index]="index"></crm-payment-status-form>
      <crm-database1c-form
        *ngSwitchCase="TypeFormEnum.DATABASE_1C"
        [index]="index"></crm-database1c-form>
      <crm-company-form
        *ngSwitchCase="TypeFormEnum.COMPANY"
        [index]="index"></crm-company-form>
      <crm-company-group-form
        *ngSwitchCase="TypeFormEnum.COMPANY_GROUP"
        [index]="index"></crm-company-group-form>
      <crm-client-form
        *ngSwitchCase="TypeFormEnum.CLIENT"
        [index]="index"></crm-client-form>
      <crm-external-user-create-form
        *ngSwitchCase="TypeFormEnum.EXTERNAL_USER_CREATE"
        [index]="index"></crm-external-user-create-form>
      <crm-external-user-edit-form
        *ngSwitchCase="TypeFormEnum.EXTERNAL_USER_EDIT"
        [index]="index"></crm-external-user-edit-form>
      <crm-user-create-form
        *ngSwitchCase="TypeFormEnum.USER_CREATE"
        [index]="index"></crm-user-create-form>
      <crm-user-edit-form
        *ngSwitchCase="TypeFormEnum.USER_EDIT"
        [index]="index"></crm-user-edit-form>
      <crm-user-group-form
        *ngSwitchCase="TypeFormEnum.USER_GROUP"
        [index]="index"></crm-user-group-form>
      <crm-role-form
        *ngSwitchCase="TypeFormEnum.ROLE"
        [index]="index"></crm-role-form>
      <crm-schedule-form
        *ngSwitchCase="TypeFormEnum.WORK_SCHEDULE"
        [index]="index"></crm-schedule-form>
      <crm-extension1c-form
        *ngSwitchCase="TypeFormEnum.EXTENSION_1C"
        [index]="index"></crm-extension1c-form>
      <crm-changelog-form
        *ngSwitchCase="TypeFormEnum.CHANGELOG"
        [index]="index"></crm-changelog-form>
      <crm-deal-group-form
        *ngSwitchCase="TypeFormEnum.DEAL_GROUP"
        [index]="index"></crm-deal-group-form>
      <crm-deal-form-sidebar
        *ngSwitchCase="TypeFormEnum.DEAL"
        [index]="index"></crm-deal-form-sidebar>
      <crm-exclusion-form
        *ngSwitchCase="TypeFormEnum.EXCLUSION"
        [index]="index"></crm-exclusion-form>
      <crm-newsletter-form-sidebar
        *ngSwitchCase="TypeFormEnum.NEWSLETTER"
        [index]="index"></crm-newsletter-form-sidebar>
      <crm-newsletter-template-form-sidebar
        *ngSwitchCase="TypeFormEnum.NEWSLETTER_TEMPLATE"
        [index]="index"></crm-newsletter-template-form-sidebar>
      <crm-helpdesk-task-form
        *ngSwitchCase="TypeFormEnum.HELPDESK"
        [index]="index"></crm-helpdesk-task-form>
      <crm-helpdesk-accept-task-form
        *ngSwitchCase="TypeFormEnum.HELPDESK_ACCEPT_TASK"
        [index]="index"></crm-helpdesk-accept-task-form>
      <crm-helpdesk-template-form
        *ngSwitchCase="TypeFormEnum.HELPDESK_TEMPLATE"
        [index]="index"></crm-helpdesk-template-form>
      <crm-helpdesk-task-type-form
        *ngSwitchCase="TypeFormEnum.HELPDESK_TASK_TYPE"
        [index]="index"></crm-helpdesk-task-type-form>
      <crm-helpdesk-eav-entity-type-form
        *ngSwitchCase="TypeFormEnum.HELPDESK_EAV_ENTITY_TYPE"
        [index]="index"></crm-helpdesk-eav-entity-type-form>
      <crm-project-form
        *ngSwitchCase="TypeFormEnum.PROJECT"
        [index]="index"></crm-project-form>
      <crm-project-template-form
        *ngSwitchCase="TypeFormEnum.PROJECT_TEMPLATE"
        [index]="index"></crm-project-template-form>
      <crm-balance-custom-row-form
        *ngSwitchCase="TypeFormEnum.BALANCE_CUSTOM_ROW"
        [index]="index"></crm-balance-custom-row-form>
      <crm-document-form-sidebar
        *ngSwitchCase="TypeFormEnum.DOCUMENT"
        [index]="index"></crm-document-form-sidebar>
      <crm-document-template-form
        *ngSwitchCase="TypeFormEnum.DOCUMENT_TEMPLATE"
        [index]="index"></crm-document-template-form>
      <crm-document-regulation-form
        *ngSwitchCase="TypeFormEnum.DOCUMENT_REGULATION"
        [index]="index"></crm-document-regulation-form>
      <crm-contract-form
        *ngSwitchCase="TypeFormEnum.CONTRACT"
        [index]="index"></crm-contract-form>
      <crm-document-salary-distribution-form
        *ngSwitchCase="TypeFormEnum.DOCUMENT_DISTRIBUTION"
        [index]="index"></crm-document-salary-distribution-form>
      <crm-nomenclature-form
        *ngSwitchCase="TypeFormEnum.NOMENCLATURE"
        [index]="index"></crm-nomenclature-form>
      <crm-nomenclature-group-form
        *ngSwitchCase="TypeFormEnum.NOMENCLATURE_GROUP"
        [index]="index"></crm-nomenclature-group-form>
      <crm-converter-form
        *ngSwitchCase="TypeFormEnum.CONVERTER"
        [index]="index"></crm-converter-form>
      <crm-access-card-form
        *ngSwitchCase="TypeFormEnum.ACCESS_CARD"
        [index]="index"></crm-access-card-form>
      <crm-kkt-form
        *ngSwitchCase="TypeFormEnum.KKT"
        [index]="index"></crm-kkt-form>
      <crm-type-of-activity-form
        *ngSwitchCase="TypeFormEnum.TYPE_OF_ACTIVITY"
        [index]="index"></crm-type-of-activity-form>
      <crm-lk-eu-helpdesk-task-form
        *ngSwitchCase="TypeFormEnum.LK_EU_HELPDESK"
        [index]="index"></crm-lk-eu-helpdesk-task-form>
      <crm-lk-eu-transit-task-form
        *ngSwitchCase="TypeFormEnum.LK_EU_TRANSIT_TASK"
        [index]="index"></crm-lk-eu-transit-task-form>
      <crm-cost-center-form
        *ngSwitchCase="TypeFormEnum.COST_CENTER"
        [index]="index"></crm-cost-center-form>
      <crm-traffic-adapter-form
        *ngSwitchCase="TypeFormEnum.TRAFFIC_ADAPTER"
        [index]="index"></crm-traffic-adapter-form>
      <crm-payer-status-form
        *ngSwitchCase="TypeFormEnum.PAYER_STATUS"
        [index]="index"></crm-payer-status-form>
      <crm-budget-classification-code-form
        *ngSwitchCase="TypeFormEnum.KBK"
        [index]="index"></crm-budget-classification-code-form>
      <crm-revenue-admin-form
        *ngSwitchCase="TypeFormEnum.REVENUE_ADMIN"
        [index]="index"></crm-revenue-admin-form>
      <crm-currency-form
        *ngSwitchCase="TypeFormEnum.CURRENCY"
        [index]="index"></crm-currency-form>
      <crm-task-scenario-form
        *ngSwitchCase="TypeFormEnum.TASK_SCENARIO"
        [index]="index"></crm-task-scenario-form>
      <crm-transit-task-form
        *ngSwitchCase="TypeFormEnum.TRANSIT_TASK"
        [index]="index"></crm-transit-task-form>
      <crm-resident-car-form
        *ngSwitchCase="TypeFormEnum.RESIDENT_CAR"
        [index]="index"></crm-resident-car-form>
      <crm-net-ping-device-form
        *ngSwitchCase="TypeFormEnum.NET_PING_DEVICE"
        [index]="index"></crm-net-ping-device-form>
      <crm-hikvision-camera-form
        *ngSwitchCase="TypeFormEnum.HIKVISION_CAMERA"
        [index]="index"></crm-hikvision-camera-form>
    </ng-container>
    <ng-template pTemplate="footer">
      <div
        *ngIf="!form.isEdit && !form.loading && form.isShowRedirectInCreate"
        class="field-checkbox">
        <p-checkbox
          [ngModel]="form.isRedirectInCreate"
          (ngModelChange)="toggleIsRedirectInCreate($event, index)"
          [binary]="true"
          inputId="isRedirectInCreate"></p-checkbox>
        <label [for]="'isRedirectInCreate'">Перейти в карточку при создании</label>
      </div>
    </ng-template>
  </p-sidebar>
</ng-container>
